import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import axios from "axios";
// import Box from '@mui/material/Box';
import { debounceFunc } from './../../helper'
import Select from '../../Components/PCSelect';
import Swal from "sweetalert2";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import FormCard from './shared/FormCard';

class CommonWarehouse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            WarehouseList: [],

            addWarehouse: false,
            WAREHOUSE_ID: "",
            WAREHOUSE_NAME: "",
            WAREHOUSE_EMAIL: "",
            WAREHOUSE_PASS: "",
            WAREHOUSE_ADDRESS: "",
            WAREHOUSE_ACTIVE: true,
        }
        this.gridRef = React.createRef(null);
    }

    async getWarehouseList(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetWarehouse.php`, formData);
        let deviceData = getDevice.data
        let WarehouseList = []
        if (deviceData.success === 1) {
            WarehouseList = deviceData.data;
            pagination.totalItems = parseInt(deviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ WarehouseList })
        this.props.toggleLoader(false)
    }

    handleAddPayAccount() {
        this.setState({ addWarehouse: true })
    }

    handleChangeInput(fieldName, event, nxtEvnt) {
        let targetValue
        switch (fieldName) {
            case "WAREHOUSE_ACTIVE":
                targetValue = nxtEvnt
                break;
            default:
                targetValue = event.target.value
                break;
        }
        this.setState({ [fieldName]: targetValue })
    }
    handleCancelPayAccount() {
        this.setState({
            addWarehouse: false,
            WAREHOUSE_ID: "",
            WAREHOUSE_NAME: "",
            WAREHOUSE_EMAIL: "",
            WAREHOUSE_PASS: "",
            WAREHOUSE_ADDRESS: "",
            WAREHOUSE_ACTIVE: true
        })
    }

    async handleSubmitPayAccount() {
        this.props.toggleLoader(true)
        let formData = {
            WAREHOUSE_ID: this.state.WAREHOUSE_ID,
            WAREHOUSE_NAME: this.state.WAREHOUSE_NAME,
            WAREHOUSE_EMAIL: "",
            WAREHOUSE_PASS: "",
            WAREHOUSE_ADDRESS: this.state.WAREHOUSE_ADDRESS,
            WAREHOUSE_ACTIVE: this.state.WAREHOUSE_ACTIVE === true ? "1" : "0"
        }

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddWarehouse.php`, formData);

        this.handleCancelPayAccount()
        this.getWarehouseList()
    }


    handleEdit(indx) {
        let { WarehouseList } = this.state;
        this.setState({
            addWarehouse: true,
            WAREHOUSE_ID: WarehouseList[indx]['WAREHOUSE_ID'],
            WAREHOUSE_NAME: WarehouseList[indx]['WAREHOUSE_NAME'],
            WAREHOUSE_EMAIL: WarehouseList[indx]['WAREHOUSE_EMAIL'],
            WAREHOUSE_ADDRESS: WarehouseList[indx]['WAREHOUSE_ADDRESS'],
            WAREHOUSE_ACTIVE: WarehouseList[indx]['WAREHOUSE_ACTIVE'] === "1" ? true : false
        })
    }


    handleDelete(ACCOUNT_ID) {
        Swal.fire({
            title: 'Do you want to delete warehouse ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.props.toggleLoader(true)
                const getShops = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/setup/DeleteWarehouse.php`, { ACCOUNT_ID });
                let shopData = getShops.data
                if (shopData.success === 1 && shopData.message === "You have successfully delete track.") {
                    Swal.fire('Warehouse Deleted!', '', 'success')
                    this.getWarehouseList()
                }
                this.props.toggleLoader(false)
            }
        })
    }

    render() {
        return (
            <Container>
                {this.state.addWarehouse === false ?
                    <PhoneClinicGrid
                        title="WAREHOUSE"
                        isEditable={true}
                        ref={this.gridRef}
                        buttonLabel="Add Warehouse"
                        onClickButton={this.handleAddPayAccount.bind(this)}
                        getData={this.getWarehouseList.bind(this)}
                        tableHeadData={[
                            {
                                label: "NAME",
                                isHidden: false
                            },
                            {
                                label: "ADDRESS",
                                isHidden: false
                            },
                            {
                                label: "ACTIVE",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.WarehouseList.map((device, idx) => (
                            <TableRow
                                className="table-rows"
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align='left' >{device.WAREHOUSE_NAME}</TableCell>
                                <TableCell align='left' >{device.WAREHOUSE_ADDRESS}</TableCell>
                                <TableCell align='center' >
                                    <Checkbox style={{ padding: "0px" }} size="small" checked={device.WAREHOUSE_ACTIVE === "1" ? true : false} disabled />
                                </TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                        { type: 'delete', onClick: this.handleDelete.bind(this, device.WAREHOUSE_ID) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.WAREHOUSE_ID ? 'Edit Warehouse' : 'Add Warehouse'} mode={this.state.WAREHOUSE_ID ? 'edit' : 'new'}
                            onCancel={this.handleCancelPayAccount.bind(this)}
                            onSave={this.handleSubmitPayAccount.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Warehouse</Form.Label>
                                    <Form.Control
                                        value={this.state.WAREHOUSE_NAME}
                                        name={"WAREHOUSE_NAME"}
                                        onChange={this.handleChangeInput.bind(this, "WAREHOUSE_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        value={this.state.WAREHOUSE_ADDRESS}
                                        name={"WAREHOUSE_ADDRESS"}
                                        onChange={this.handleChangeInput.bind(this, "WAREHOUSE_ADDRESS")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Active</Form.Label>
                                    <FormGroup>
                                        <Checkbox size="small" checked={this.state.WAREHOUSE_ACTIVE} onChange={this.handleChangeInput.bind(this, "WAREHOUSE_ACTIVE")} />
                                    </FormGroup>
                                </Form.Group>
                            </Col>


                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default CommonWarehouse;